import {map, reject} from "underscore";

const filterDeleted = (items, relation) =>
  reject(items, (item) => item?.isDeleted || (relation && item?.[relation]?.isDeleted));

const filterDisabled = (items, relation) =>
  reject(items, (item) => item?.[relation]?.isEnabled === false);

const normalizeActionRole = (actionRole) => ({
  ...actionRole,
  role: {
    ...actionRole.role,
    users: filterDeleted(actionRole.role?.users, "user"),
  },
});

const normalizeIncidentRole = (incidentRole) => ({
  ...incidentRole,
  role: {
    ...incidentRole.role,
    users: filterDeleted(incidentRole.role?.users),
  },
});

const normalizeIncident = (incident) => {
  if (!incident || incident.isDeleted) {
    return;
  }

  return {
    ...incident,
    // Keep leadUser, including its deletion state. A deleted lead is not the current lead, but it
    // also does not make the incident satisfy a "no lead" condition.
    users: filterDeleted(incident.users),
    roles: map(
      filterDisabled(filterDeleted(incident.roles, "role"), "role"),
      normalizeIncidentRole,
    ),
    types: filterDeleted(incident.types, "type"),
  };
};

const normalizeAction = (action) => {
  if (!action || action.isDeleted) {
    return;
  }

  return {
    ...action,
    // Keep user, including its deletion state. Ownership and "unowned" are separate conditions.
    incident: normalizeIncident(action.incident),
    roles: map(filterDisabled(filterDeleted(action.roles, "role"), "role"), normalizeActionRole),
  };
};

export const filterForActivityGrants = ({action}) => ({action: normalizeAction(action)});
